import { createSlice } from "@reduxjs/toolkit";

const permissionSlice = createSlice({
    name: 'permission',
    initialState: {
        permissionActive: {}
    },
    reducers: {
        onSetActivePermission: (state, { payload }) => {
            state.permissionActive = payload
        }
    }
})

const { onSetActivePermission } = permissionSlice.actions

export {
    onSetActivePermission,
    permissionSlice
}